import { render } from "./NavigationComponent.vue?vue&type=template&id=344f231c&scoped=true"
const script = {}

import "./NavigationComponent.vue?vue&type=style&index=0&id=344f231c&scoped=true&lang=css"
import "./NavigationComponent.vue?vue&type=style&index=1&id=344f231c&lang=css"

import exportComponent from "/Users/daniel/Documents/CETECREA/cetecrea/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-344f231c"]])

export default __exports__